import { SegmentPropertiesMap } from '@/models/segment';

/**
 * Events reported to Segment via the trackWithSegment util in segment.ts
 * Ideally, all events should be arranged in alphabetical order.
 */

export const SEGMENT_EVENTS = Object.freeze<Record<keyof SegmentPropertiesMap, string>>({
  accountingCustomerMapClicked: 'Accounting Customer Map Clicked',
  accountingCustomerMapFiltered: 'Accounting Customer Map Filtered',
  accountingCustomerMapped: 'Accounting Customer Mapped',
  accountingCustomerUnmapped: 'Accounting Customer Unmapped',
  accountingProductMapClicked: 'Accounting Product Map Clicked',
  accountingProductMapFiltered: 'Accounting Product Map Filtered',
  accountingProductMapped: 'Accounting Product Mapped',
  accountingProductUnmapped: 'Accounting Product Unmapped',
  addNewUserClicked: 'Add New User Clicked',
  addToCartModalInitiated: 'Add To Cart Modal Initiated',
  approveOrderClicked: 'Approve Order Clicked',
  attachManifestCancelled: 'Attach Manifest Cancelled',
  attachManifestClicked: 'Attach Manifest Clicked',
  attachManifestClickedWithSuggestionAvailable: 'Attach Manifest Clicked with Suggestion Available',
  backToReviewSuggestedManifest: 'Back to Review Suggested Manifest',
  bulkPriceBackClicked: 'Bulk Price Back Clicked',
  bulkPriceConfirmClicked: 'Bulk Price Confirm Clicked',
  bulkPriceExited: 'Bulk Price Exited',
  bulkPriceInfoAdded: 'Bulk Price Info Added',
  bulkPriceUpdateClicked: 'Bulk Price Update Clicked',
  buyerProductMultiAddToCart: 'Buyer Product Multi Add To Cart',
  cartPaymentOptionChanged: 'Payment Option Changed',
  catManWaitlisted: 'CatMan Waitlisted',
  cloneOrderClicked: 'Clone Order Clicked',
  comparePlansPageExited: 'Compare Plans Page Exited',
  comparePlansPageViewed: 'Compare Plans Page Viewed',
  createBatchFromS2sPackage: 'Create Batch from S2S Package',
  connectAccountingClicked: 'Connect Accounting Clicked',
  createMappingClicked: 'Create Mapping Clicked',
  createOrderFormClicked: 'Create Order Form Clicked',
  createProductFromS2sClicked: 'Create Product from S2S Clicked',
  deactivateUserClicked: 'Deactivate User Clicked',
  editMappingClicked: 'Edit Mapping Clicked',
  editUserClicked: 'Edit User Clicked',
  experimentAllocation: 'Experiment Allocation',
  filterS2sPackagesPage: 'Filter S2S Packages Page',
  inventoryInsightsBetaCustomerFeedbackSent: 'Inventory Insights Beta Customer Feedback Sent',
  inventoryInsightsEnrollmentBillingPOCManaged: 'Billing POC Managed',
  inventoryInsightsEnrollmentCompleted: 'Wizard Completed',
  inventoryInsightsEnrollmentExited: 'Wizard Exited',
  inventoryInsightsEnrollmentInfoClicked: 'Wizard Info Clicked',
  inventoryInsightsEnrollmentNavigationClicked: 'Wizard Navigation Clicked',
  inventoryInsightsEnrollmentPaymentMethodsManaged: 'Payment Methods Managed',
  inventoryInsightsEnrollmentPosInfoError: 'POS Info Error',
  inventoryInsightsEnrollmentPosInfoValidated: 'POS Info Validated',
  inventoryInsightsEnrollmentStepViewed: 'Wizard Step Viewed',
  inventoryInsightsEnrollmentWaitlistClicked: 'Waitlist Clicked',
  inventoryInsightsNegotiateClipboard: 'Inventory Insights Negotiate Clipboard',
  inventoryInsightsNegotiateClosed: 'Inventory Insights Negotiate Modal Closed',
  inventoryInsightsNegotiateCommunicationChanged: 'Inventory Insights Negotiate Communication Changed',
  inventoryInsightsNegotiateEmailSent: 'Inventory Insights Negotiate Email Message Sent',
  inventoryInsightsNegotiateRecipientPreSelected: 'Inventory Insights Message Recipient Pre Selected',
  inventoryInsightsParamsChanged: 'Inventory Insights Params Changed',
  inventoryInsightsRecommendedActionClicked: 'Inventory Insights Recommended Action Clicked',
  inventoryInsightsRecommendedActionImpression: 'Inventory Insights Recommended Action Impression',
  manifestSaved: 'Manifest Saved',
  mergeAuthFlowError: 'Merge Auth Flow Error',
  mergeAuthFlowExit: 'Merge Auth Flow Exit',
  mergeAuthFlowSuccessful: 'Merge Auth Flow Successful',
  messageDiscussionOpened: 'Message Discussion Opened',
  messageRecipientSelected: 'Message Recipient Selected',
  messageSent: 'Message Sent',
  messagesSearched: 'Messages Searched',
  messageStatusChanged: 'Message Status Changed',
  multiStoreAddToCartModalClosed: 'Multi Store Add To Cart Modal Closed',
  newMessageModalOpened: 'New Message Modal Opened',
  newUserAdded: 'New User Added',
  orderAccepted: 'Order Accepted',
  orderBackorder: 'Order Backorder',
  orderCancelled: 'Order Cancelled',
  orderCombined: 'Order Combined',
  orderComplete: 'Order Complete',
  orderDraft: 'Order Draft',
  orderFormComplianceFormSubmitted: 'Order Form Compliance Form Submitted',
  orderFormCreated: 'Order Form Created',
  orderFormPurchased: 'Order Form Purchased',
  orderFormShared: 'Order Form Shared',
  orderFormSubmitClicked: 'Order Form Submit Clicked',
  orderFormViewed: 'Order Form Viewed',
  orderFulfilled: 'Order Fulfilled',
  orderInformationUpdated: 'Order Information Updated',
  orderRejected: 'Order Rejected',
  orderShipped: 'Order Shipped',
  orderSubmitted: 'Order Submitted',
  packagesBulkAssignedToLLProduct: 'Packages Bulk Assigned to LL Product',
  packagesUnmappedFromLLProduct: 'Packages Unmapped From LL Product',
  plansAndBillingBillingPOCManaged: 'Billing POC Managed',
  plansAndBillingDeletePaymentClicked: 'Delete Payment Clicked',
  plansAndBillingEditBillingInfoClicked: 'Edit Billing Info Clicked',
  plansAndBillingEditPaymentMethodModalExited: 'Edit Payment Method Modal Exited',
  plansAndBillingEditPlansInfoClicked: 'Edit Plans Info Clicked',
  plansAndBillingFilterByApplied: 'Filter by Applied',
  plansAndBillingInvoiceDetailsClicked: 'Invoice Details Clicked',
  plansAndBillingMakePaymentClicked: 'Make Payment Clicked',
  plansAndBillingModifyPlanAMEmailClicked: 'Modify Plan AM Email Clicked',
  plansAndBillingModifyPlanModalSubmitted: 'Modify Plan Modal Submitted',
  plansAndBillingPaymentMethodsManaged: 'Payment Methods Managed',
  plansAndBillingSearchByApplied: 'Search by Applied',
  plusMembershipClicked: 'Plus Membership CTA Clicked',
  productAddEditMVPCancelClicked: 'Add Edit Product Cancel Clicked',
  productAddEditMVPFieldEdited: 'Add Edit Product Edited',
  productAddEditMVPSaveClicked: 'Add Edit Product Save Clicked',
  productAddEditMVPVersionClicked: 'Add Edit Product Version Clicked',
  productAddEditMVPAddFromTemplateClicked: 'Add Edit Product Add from Template Clicked',
  productCreatedFromS2sInformation: 'Product Created from S2S Information',
  productDetailsViewed: 'Product Details Viewed',
  productMappingCancelled: 'Product Mapping Cancelled',
  productMappingLicenseChanged: 'Product Mapping License Changed',
  productsMapped: 'Products Mapped',
  productSpotlightImpression: 'Product Spotlight Impression',
  productSpotlightProductClicked: 'Product Spotlight Product Clicked',
  productSpotlightProductAddedToCart: 'Product Spotlight Product Added To Cart',
  productSpotlightProductEditedInCart: 'Product Spotlight Product Edited In Cart',
  productSpotlightProductRemovedFromCart: 'Product Spotlight Product Removed From Cart',
  publicMenuLoginClicked: 'Public Menu Login Clicked',
  publicMenuRegisterClicked: 'Public Menu Register Clicked',
  publicMenuShared: 'Public Menu Shared',
  quickBooksInvoicePushed: 'QuickBooks Invoice Pushed',
  reactivateUserClicked: 'Reactivate User Clicked',
  recentlyPurchasedImpression: 'Recently Purchased Brands/Vendors Impression',
  recentOrdersClicked: 'Recent Orders Clicked',
  reconcileInventoryClicked: 'Reconcile Inventory Clicked',
  refreshManifestsClicked: 'Refresh Manifests Clicked',
  removeProductMapping: 'Remove Product Mapping',
  relinkAccountingClicked: 'Relink Accounting Clicked',
  retailEnrollmentClicked: 'Retail Enrollment CTA Clicked',
  retailEnrollmentImpression: 'Retail Enrollment Impression',
  retailEnrollmentStarted: 'Retail Enrollment Started',
  reviewMatchedManifestClicked: 'Review Matched Manifest Clicked',
  reviewSuggestedManifestCancelled: 'Review Suggested Manifest Cancelled',
  s2sCreateProductModalExited: 'S2S Create Product Modal Exited',
  s2sItemSelectedForProductCreation: 'S2S Item Selected for Product Creation',
  searchForS2sItemForProductCreation: 'Search for S2S Item for Product Creation',
  searchManifestsClicked: 'Search Manifests Clicked',
  searchS2sPackagesPage: 'Search S2S Packages Page',
  selectManifest: 'Select Manifest',
  selectMetrcItemToMap: 'Select Metrc Item to Map',
  sgoCustomerSelected: 'Customer Selected',
  shareMenuModalViewed: 'Share Menu Modal Viewed',
  singlePackageAssignedToLLProduct: 'Single Package Assigned to LL Product',
  suggestedManifestAttached: 'Suggested Manifest Attached',
  unselectManifest: 'Unselect Manifest',
  unselectMetrcItemToMap: 'Unselect Metrc Item to Map',
  userDeactivated: 'User Deactivated',
  userEdited: 'User Edited',
  userReactivated: 'User Reactivated',
  userUpdateCanceled: 'User Update Canceled',
  viewMessagesClicked: 'View Messages Clicked',
  viewS2SQuantity: 'View S2S Quantity',
});

/**
 * @Deprecated use SEGMENT_EVENTS instead
 */
export enum SegmentEvent {
  AcceptTermsAndConditions = 'Global T&Cs Accepted',
  AdClick = 'Ad Click',
  AdImpression = 'Ad Impression',
  AdsManagerCreationFormCompleted = 'Ads Manager - Campaign Creation Form Completed',
  AdsManagerCreationFormStepCompleted = 'Ads Manager - Campaign Creation Form Step Completed',
  AdsManagerCtaClicked = 'Ads Manager - Campaign CTA Clicked',
  BrandClicked = 'Brand Clicked',
  BrandImpression = 'Brand Impression',
  BrandMenuClick = 'Brand Menu - Click',
  BrandMenuSearch = 'Brand Menu - Search',
  BulkEditProductsClicked = 'Bulk Edit Products Clicked',
  BulkEditProductsSubmitted = 'Bulk Edit Products Submitted',
  BuyerModalProductAdded = 'Buyer Modal Product Added',
  BuyerProductAddedToCart = 'Buyer Product added to cart',
  BuyerProductEdited = 'Buyer Product Edited',
  BuyerProductRemoved = 'Buyer Product Removed',
  BuyerProductSearched = 'Buyer Product Searched',
  CatManCurious = 'CatMan Curious',
  CatManImpression = 'CatMan Impression',
  CompanyLicenseChanged = 'Company/License Changed',
  CustomMenuExport = 'Custom Menu Export',
  EmptyBrandCatalogViewed = 'Empty Brand Catalog Viewed',
  FilterClicked = 'Filter Clicked',
  ForwardOrderCancelled = 'Forward Status: cancelled',
  InAppMessageSent = 'In App Message Sent',
  InventoryInsightsCategoryChanged = 'Inventory Insights Category Changed',
  InventoryProductLineCreateClicked = 'product_line_create_clicked',
  InventoryProductLineInfoAdd = 'product_line_add_clicked',
  InventoryProductLineInfoAdded = 'product_line_info_added',
  InventoryProductLineInfoCancel = 'product_line_cancel_clicked',
  InventoryProductLineRemoved = 'product_line_deleted',
  ManualOrderCreated = 'Manual Order Created',
  NativeInsightCurious = 'Native Insight Curious',
  NativeInsightImpression = 'Native Insight Impression',
  NativeInsightInterested = 'Native Insight Interested',
  NewBrandWidgetClick = 'New Brand Widget Click',
  NewBrandWidgetDisplayed = 'New Brand Widget Displayed',
  NewBrandWidgetImpression = 'New Brand Widget Impression',
  NotificationPreferenceClicked = 'Notification Preference Clicked',
  NotificationPreferencesClick = 'Notification Preferences Clicked',
  OrderCreated = 'Order Created',
  OrderPaidStatusChanged = 'Order Paid Status Changed',
  OrderReceived = 'Order Received',
  OrdersSentAllLicensesSelected = 'Orders Sent All Licenses Selected',
  OrderStatusSelectedCancelled = 'Order Status Selected - Cancelled',
  OrderSubmittedCollaborative = 'Order submitted - Collaborative',
  ProductClick = 'Product Click',
  ProductImpression = 'Product Impression',
  ProductRecommendationCarouselImpression = 'Product Recommendation Carousel Impression',
  ProductSpotlightWidgetClick = 'Product Spotlight Widget Click',
  ProductSpotlightWidgetImpression = 'Product Spotlight Widget Impression',
  ProductTemplateAddClicked = 'Product Template Clicked',
  ProductTemplateCancelClicked = 'Product Template Cancel Clicked',
  ProductTemplateCreated = 'Product Template Created',
  ProductTemplatePickClicked = 'Product Template Picked',
  ProductTemplateUpdated = 'Product Template Updated',
  ProductToggled = 'Product Toggled',
  PurchaseListItemAddedToCart = 'Purchase List Item Added to Cart',
  RetailerRegistrationAboutYouViewed = 'Retailer Registration About You Section Viewed',
  RetailerRegistrationLandingViewed = 'Retailer Registration Landing Page Viewed',
  RetailerRegistrationNavigationNextClicked = 'Retailer Registration Next Clicked',
  RetailerRegistrationNavigationPreviousClicked = 'Retailer Registration Previous Clicked',
  RetailerRegistrationReferralAndTermsViewed = 'Retailer Registration Referral & Terms Section Viewed',
  RetailerRegistrationReviewInformationViewed = 'Retailer Registration Review Information Section Viewed',
  RetailerRegistrationSidebarClicked = 'Retailer Registration Sidebar Clicked',
  RetailerRegistrationSubmission = 'Retailer Registration Agree and Submit Clicked',
  RetailerRegistrationYourBusinessViewed = 'Retailer Registration Your Business Section Viewed',
  RetailerRegistrationYourLicensesViewed = 'Retailer Registration Your Licenses Section Viewed',
  SampleRequestSent = 'Sample Request Sent',
  SkyscraperImpression = 'Skyscraper Impression',
  VendorClicked = 'Vendor Clicked',
  VendorImpression = 'Vendor Impression',
  VendorMenuClick = 'Vendor Menu - Click',
  ViewCollabOrdersClicked = 'Order viewed - Collaborative (All)',
}
